import { DatePipe } from '@angular/common';
import { Component, TemplateRef } from '@angular/core';
import { Router } from '@angular/router';
import { listContracts } from '@core/models/candidat';
import { environment } from '@env/environment';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { LocalStorageService } from '@core/services/local-storage.service';
import { EsnCandidatService } from '@core/services/esn-candidat/esn-candidat.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { CvType } from '@core/models/enums/cv-type.enum';
import { ExportService } from '@shared/services/export.service';
import { serverError } from '@core/models/messages';
import { Subject, takeUntil } from 'rxjs';
export interface addSkill {
  name: string;
}
@Component({
  selector: 'app-update-intervenant',
  templateUrl: './update-intervenant.component.html',
  styleUrls: ['./update-intervenant.component.css']
})
export class UpdateIntervenantComponent {
 /* string */
 url: string = environment.baseUrl;
 isLastPagee: boolean = false;
 hasPagination: boolean = false;
 isEmptyList: boolean = false;
 pagination : boolean =false;

 /* number */
 modalRef?: BsModalRef;
 /* number */
 totalItems!: number;
 itemsPerPage: number = 5;
 currentPage: number = 1;
 startIndex: number = 0;
 endIndex: number = 5;
 /* object */
 selectedCandidate!: any;
 /* array */
 contratRequest = listContracts;
 linkedinPrefix = 'https://www.linkedin.com/in/';
 skills: any = [];
 skillsCv:any
 colorsHeader: string[] = [
   '#FBF2E9',
   '#E8F6FC',
   '#FDEFEE',
   '#FFF3D7',
   '#FBF2E9',
 ];
 idinter:any
 /* unsubscription */
 private unsubscribeAll: Subject<void> = new Subject();
 cvTypeEnum = CvType

 constructor(
   private candidatService: EsnCandidatService,
   private spinner: NgxSpinnerService,
   private router: Router,
   private toastr: ToastrService,
   private datePipe: DatePipe,
   private localStorageService: LocalStorageService,
   private modalService: BsModalService,
   private exportService: ExportService,
 ) {}
 ngOnInit() {
   window.scrollTo(0, 0);
   this.idinter = this.localStorageService.getData('id');
   this.getCandidateById();
   this.getSkills();
 }
 /* get pagination items */
 getItems(event?: any) {
   if (event) {
     this.startIndex = event.startIndex;
     this.endIndex = event.endIndex;
     this.itemsPerPage = event.itemsPerPage;
     this.currentPage = event.currentPage;
     if (this.endIndex > this.totalItems) {
       this.endIndex = this.totalItems;
     }
     if( (this.startIndex !=0 || this.endIndex !=5) || this.pagination == true){     
       this.pagination = true
     this.getSkills();
     }
   }
 }

 /* get candidate by id */
 image: any;
 capitalizeFirstLetter(string:any) {
   if (!string) return string;

   
   return string.charAt(0).toUpperCase() + string.slice(1);
 } 
 closeModal() {

  this.modalRef!.hide();
}
 getCandidateById(): void {
   this.spinner.show();
   console.log('this.idcandidat', this.idinter);
   this.candidatService
     .getUserById(this.idinter)
     .pipe(takeUntil(this.unsubscribeAll))
     .subscribe({
       next: (res: any) => {
         console.log('res', res);
         this.spinner.hide();
         this.selectedCandidate = res.data[0];
         this.image = res.data[0].image_url;
         // Ensure that desired_contract is an array
         this.selectedCandidate.desired_contract =
           this.selectedCandidate.desired_contract || [];

         // Iterate over desired_contract and map to labels
         this.selectedCandidate.desired_contract =
           this.selectedCandidate.desired_contract.map((contractId: any) => {
             return this.contratRequest[contractId - 1]?.label || '';
           });
         this.selectedCandidate.current_country =
           !this.selectedCandidate.current_country ||
           this.selectedCandidate.current_country == 'null'
             ? ''
             : this.selectedCandidate.current_country;
         this.selectedCandidate.linkedin_link =
           !this.selectedCandidate.linkedin_link ||
           this.selectedCandidate.current_country == 'null'
             ? ''
             : this.selectedCandidate.linkedin_link;
         this.selectedCandidate.date_first_experience =
           !this.selectedCandidate.date_first_experience ||
           this.selectedCandidate.date_first_experience == 'null'
             ? ''
             : this.selectedCandidate.date_first_experience;
         this.selectedCandidate.desired_salary =
           !this.selectedCandidate.desired_salary ||
           this.selectedCandidate.desired_salary == 'null'
             ? ''
             : this.selectedCandidate.desired_salary;
         this.selectedCandidate.destination_country =
           !this.selectedCandidate.destination_country ||
           this.selectedCandidate.destination_country == 'null'
             ? ''
             : this.selectedCandidate.destination_country;

         this.parseData('certificat');
         this.parseData('desired_contract');
         this.parseData('diplome');
         this.parseData('mobility');
         let data: any = [];

         this.selectedCandidate.desired_contract = data;
       },
       error: (err: Error) => {
         this.spinner.hide();
       },
     });
 }
 openModal(template: TemplateRef<any>, data?: any, mode?: string) {
  this.modalRef = this.modalService.show(template, { backdrop: 'static' });

}
 parseData(name: string) {
   if (
     typeof this.selectedCandidate[name] == 'string' &&
     this.selectedCandidate[name] == 'null'
   ) {
     this.selectedCandidate[name] = [];
   } else {
     this.selectedCandidate[name] = JSON.parse(this.selectedCandidate[name]);
   }
 }
 /* open pdf in new target blank */
 OpenPDF(typeFile?: string) {
   this.spinner.show();
   const fileUrl = !typeFile
     ? `${this.url}/api/User/file/gallery_cvs/${this.selectedCandidate.cv}`
     : `${this.url}/api/ResponseCandidate/GetFile/${this.selectedCandidate.file_test}`;
   this.candidatService.downloadPDF(fileUrl).subscribe((blob) => {
     const fileURL = URL.createObjectURL(blob);
     this.spinner.hide();
     window.open(fileURL, '_blank');
   });
 }
 /* download file */
 downloadFile(typeFile?: string) {
   if (typeFile && typeFile != '')
     this.selectedCandidate.file_test =
       this.selectedCandidate.file_test.split('/')[1];
   this.spinner.show();
   const fileUrl = !typeFile
     ? `${this.url}/api/User/file/gallery_cvs/${this.selectedCandidate.cv}`
     : `${this.url}/api/ResponseCandidate/GetFile/${this.selectedCandidate.file_test}`;
   this.candidatService.downloadPDF(fileUrl).subscribe((blob) => {
     const fileURL = URL.createObjectURL(blob);
     const a = document.createElement('a');
     a.href = fileURL;
     a.download = !typeFile
       ? `${this.selectedCandidate.ID_user}_${
           this.selectedCandidate.first_name
         }_${
           this.selectedCandidate.last_name
         }_CV.${this.selectedCandidate!.cv.split('.').pop()}`
       : `${this.selectedCandidate.ID_user}_${
           this.selectedCandidate.first_name
         }_${
           this.selectedCandidate.last_name
         }_QCM.${this.selectedCandidate!.file_test.split('.').pop()}`;
     document.body.appendChild(a);
     a.click();
     this.spinner.hide();
   });
 }
 /* get candidate skills */

 getSkills() {
   this.candidatService
     .getSkillsCandidate(this.idinter)
     .pipe(takeUntil(this.unsubscribeAll))
     .subscribe({
       next: (res) => {
         this.skills = res.data.categoriesWithSubCategoriesAndSkills.slice(this.startIndex, this.endIndex);
         this.skillsCv = res.data.categoriesWithSubCategoriesAndSkills.slice(this.startIndex, this.endIndex)
         .map((category:any) => ({
           ...category,
           sub_category: category.sub_category
             .map((subCategory:any) => ({
               ...subCategory,
               skills: subCategory.skills.filter((skill:any) => skill.checked === '1')
             }))
             .filter((subCategory:any) => subCategory.skills.length > 0)
         }))
         .filter((category:any) => category.sub_category.length > 0);
         const skillsTextLength = this.selectedCandidate?.skills_text?.length ? 1 : 0;
         this.totalItems = res.data.count + skillsTextLength;
         this.hasPagination = this.totalItems > this.itemsPerPage;
         this.isLastPagee = (this.endIndex >= this.totalItems);
         this.isEmptyList =this.skills?.length===0 && this.selectedCandidate?.skills_text.length === 0;
       },
       error: () => {
         this.toastr.error(serverError);
       },
     });
 }
 //
 /* unsubscribe from api */
 ngOnDestroy() {
   this.unsubscribeAll.next();
   this.unsubscribeAll.complete();
 }

  /**
  * Download CV.
  *  
  * @param {string} cvType - The type of CV to export (e.g., WEGESTU or ESN).
  * @param {number} isAnonymous - Whether to export an anonymous version of the CV (1 : not anonymous, 2 : anonymous) .
  * @returns {void}
  */
  downloadCV(cvType : string, isAnonymous: number){   
    if(cvType === this.cvTypeEnum.WEGESTU){
      this.exportCVCandidate(isAnonymous, null)
    }else{
      this.exportCVCandidate(isAnonymous, this.selectedCandidate?.ESN_id)
    }
}

// @TOFIX: duplicated
/**
* Exports the CV of a candidate based on the specified type and company ID.
*
* @param {number} type - The type of CV to export (e.g., 1 for standard, 2 for anonymous)
* @param {number | null} idCompany - The ID of the company for which the CV is being exported.
*                          Use `null` if no specific company is associated.
*/
exportCVCandidate(type: number, idCompany : number | null) {

  this.spinner.show();
  const candidate = {
    ids: [this.idinter],
    last_name: this.selectedCandidate?.last_name,
    first_name: this.selectedCandidate?.first_name
  } 
  const exportMethod = idCompany !== null
    ? this.exportService.exportCVEsnCandidate(candidate, type, idCompany)
    : this.exportService.exportCVWegestuCandidate(candidate, type);

  exportMethod.subscribe({
    next: () => {
      this.spinner.hide();
    },
    error: () => {
      this.spinner.hide();
    },
  });
}
}